import classNames from "classnames";
import { ReactNode } from "react";

export type BadgeStyle =
  | "inactive"
  | "neutral"
  | "negative"
  | "warning"
  | "success";

export type IndicatorProps = {
  text: ReactNode;
  className?: string;
  badgeStyle?: BadgeStyle;
  size?: "large" | "small";
  fill?: "filled" | "outline";
};

export const Indicator = ({
  text,
  className,
  badgeStyle = "neutral",
  size = "small",
  fill = "filled",
}: IndicatorProps) => {
  return (
    <div
      className={classNames(
        "rounded-md text-sm font-semibold whitespace-nowrap inline-block",
        className,
        {
          "py-1 px-3": size === "small",
          "py-2 px-4": size === "large",
          "text-gray-200": badgeStyle === "inactive",
          "text-primary-500": badgeStyle === "neutral",
          "text-error": badgeStyle === "negative",
          "text-success": badgeStyle === "success",
          "text-warning": badgeStyle === "warning",
          "bg-gray-25": badgeStyle === "inactive" && fill === "filled",
          "bg-[#DFE2FA]": badgeStyle === "neutral" && fill === "filled",
          "bg-error-50": badgeStyle === "negative" && fill === "filled",
          "bg-success-secondary": badgeStyle === "success" && fill === "filled",
          "bg-warning-50": badgeStyle === "warning" && fill === "filled",
          "bg-white border border-solid": fill === "outline",
          "border-gray-100": badgeStyle === "inactive",
          "border-[#DFE2FA]": badgeStyle === "neutral",
          "border-error-100": badgeStyle === "negative",
          "border-success-200": badgeStyle === "success",
          "border-warning-200": badgeStyle === "warning",
        }
      )}
    >
      {text}
    </div>
  );
};
